<template lang="pug">
    div#main-slideshow
        VueperSlides(fade, :parallax="parallax", autoplay, slide-content-outside="top", slide-content-outside-class="max_widthed", :touchable="false", :slide-ratio="0.3")
            VueperSlide(
                v-for="(slide, i) in slides",
                :key="i",
                :image="`${baseUrl}img/slideshow/` + slide.image",
                
            )

</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.min.css';

export default {
  name: 'mainSlideShow',
  components: {
      VueperSlides,
      VueperSlide
  },
  data: function () {
      return {
          baseUrl: process.env.BASE_URL,
          parallax: 0.1,
          slides: [
              {
                  title: 'slideshow_1',
                  content: 'slideshow_1',
                  image: 'SAM_0560.jpg'
              },              
              {
                  title: 'slideshow_2',
                  content: 'slideshow_2',
                  image: '47.jpg'
              },
              {
                title: 'slideshow_3',
                  content: 'slideshow_3',
                  image: '52.jpg'
              },
              {
                  title: 'slideshow_4',
                  content: 'slideshow_4',
                  image: 'DSC_0081.jpg'
              },
              {
                  title: 'slideshow_6',
                  content: 'slideshow_6',
                  image: 'SAM_0757.jpg'
              },
              
          ]
      };
  }
}
</script>

<style scoped>
/* .slide-content {
    display: block;
    max-width: 50vw;
} */

.vueperslide__content-wrapper--outside-top {
    transition: 0.3s ease-in-out;
    opacity: 1;
    transform: scale(1);
}

.vueperslide--animated .vueperslide__content-wrapper--outside-top {
    transition: 0.15s ease-in-out;
    opacity: 0;
    transform: scale(0);
}
</style>
